'use client';

import { useId, useState } from 'react';

export function Disclosure({ summary, className = '', children }) {
  const id = useId();
  const [open, setOpen] = useState(false);
  return <div className={`disclosure ${className}`} data-open={open}>
    <button className="disclosure-toggle" type="button" aria-expanded={open} aria-controls={id} onClick={() => setOpen(current => !current)}>
      {summary}
    </button>
    <div className="disclosure-body" id={id} aria-hidden={!open} inert={!open}>
      <div className="disclosure-content">{children}</div>
    </div>
  </div>;
}
